import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { IndustrialBackdrop } from './ui/IndustrialBackdrop';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="relative isolate overflow-hidden border-y border-slate-700/60 bg-slate-900 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-42" data-mp="12uesp8cps57z">
      <IndustrialBackdrop data-id="element-43" data-mp="1cqrku1sm2b0m" />
      <div className="mx-auto max-w-4xl px-4" data-id="element-44" data-mp="1cpzt5224wxfm">
        <h2 id="closing-title" className="text-balance text-center text-3xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-45" data-mp="1coool00v7lng">
          Stop Guessing. <span className="text-amber-400" data-id="element-46" data-mp="1litijsbapd77">Start Understanding Fluid Power.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-47" data-mp="1hi9nqve72lo8">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-amber-400 bg-slate-950/90 px-4 py-3 text-sm font-semibold text-white" data-id="element-48" data-mp="1vi0xul1lbhwy" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-49" data-mp="2gbvilqx88sil" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}